import { render, staticRenderFns } from "./ProductionOffice.vue?vue&type=template&id=296ec937&scoped=true&"
import script from "./ProductionOffice.vue?vue&type=script&lang=js&"
export * from "./ProductionOffice.vue?vue&type=script&lang=js&"
import style0 from "./ProductionOffice.vue?vue&type=style&index=0&id=296ec937&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296ec937",
  null
  
)

export default component.exports